<template>
  <div class="mainWrapper">
  <div class="contentWrapper wrapper-ThankYou">
    <Header />
    <!-- <div class="container ess-calcPage"> -->
      <!-- <b-button variant='success' @click="proceedRequest" class="my-5">На главную</b-button> -->
    <!-- </div> -->

      <div class="top-section-statistic">
          <div class="statistic-title">Спасибо за обращение!</div>
          <div class="statistic-suptitle"> Мы свяжемся с Вами в ближайшее время. </div>
          <b-button variant='success' @click="proceedRequest" class="my-5">На главную</b-button>
      </div>
      <div class="bg-img-statistic">
          <img src="https://energosave.pro/img/sun_ess.svg" alt="">
      </div>

    
  </div>
</div>
</template>

<script>
  import Header from '@/components/Header.vue'

export default {
  name: 'Cart',
  components: {
    Header,
  },
  methods:{
    proceedRequest(){
      this.$router.push('/')
    }
  }
}
</script>
